import * as actionTypes from '../../types/orders';

export const initialState = {
  isFetching: false,
  pagination: {},
  paginationFetching: true,
  error: false,
  bulk_actions: {},
  orders: [],
  config: {},
  data: {
    statuses: [],
  },
  filters: {},
  exportListFetching: false,
  exportConfig: {},
  exportData: {
    exports: [],
    pagination: {},
  },
};

const orders = (state = initialState, action) => {
  switch (action.type) {
  case actionTypes.FETCHING: {
    return {
      ...state,
      isFetching: action.payload,
    };
  }

  case actionTypes.FETCHING_PAGINATION: {
    return {
      ...state,
      paginationFetching: action.payload,
    };
  }

  case actionTypes.ERROR: {
    return {
      ...state,
      error: action.payload,
    };
  }

  case actionTypes.ERROR_INIT: {
    return {
      ...state,
      ...initialState,
      error: action.payload.error,
    };
  }

  case actionTypes.UPDATE_LIST: {
    return {
      ...state,
      isFetching: true,
    };
  }
  case actionTypes.UPDATE_LIST_SUCCESS: {
    return {
      ...state,
      isFetching: false,
      data: {
        ...state.data,
        orders: action.payload.orders,
      },
    };
  }

  case actionTypes.GET_ORDERS_LIST_SUCCESS: {
    const orders = action?.data?.queue?.id ? (state.data?.orders ? state.data.orders : []) : action.data.orders;

    return {
      ...state,
      data: {
        ...action.data,
        orders,
      },
      filters: action.data.filters,
      pagination: action?.data.pagination,
    };
  }

  case actionTypes.GET_PAGINATION_SUCCESS: {
    return {
      ...state,
      pagination: action.data,
      paginationFetching: false,
    };
  }

  case actionTypes.GET_EXPORT_CONFIG: {
    return {
      ...state,
    };
  }

  case actionTypes.GET_EXPORT_CONFIG_SUCCESS: {
    return {
      ...state,
      exportConfig: action.data,
    };
  }

  case actionTypes.GET_EXPORT_CONFIG_ERROR: {
    return {
      ...state,
    };
  }

  case actionTypes.GET_CONFIG_SUCCESS: {
    return {
      ...state,
      config: action.data,
    };
  }

  // fake users search
  case actionTypes.GET_USERS_LIST_SEARCH: {
    return {
      ...state,
      users: [],
    };
  }

  case actionTypes.GET_USERS_LIST_SEARCH_SUCCESS: {
    return {
      ...state,
      users: action.data,
    };
  }

  case actionTypes.GET_STATUSES_COUNTS_SUCCESS: {
    return {
      ...state,
      data: {
        ...state.data,
        statuses: action.data,
      },
    };
  }

  case actionTypes.GET_EXPORT_LIST: {
    return {
      ...state,
      exportListFetching: true,
    };
  }

  case actionTypes.GET_EXPORT_LIST_SUCCESS: {
    return {
      ...state,
      exportListFetching: false,
      exportData: action.payload,
    };
  }

  case actionTypes.GET_EXPORT_LIST_ERROR: {
    return {
      ...state,
      exportListFetching: false,
      error: true,
    };
  }

  case actionTypes.DELETE_HINT: {
    return {
      ...state,
      data: {
        ...state.data,
        cancel_reason_hints: state.data.cancel_reason_hints.filter((hint) => Number(hint.id) !== Number(action.payload.id)),
      },
    };
  }

  default: {
    break;
  }
  }

  return state;
};

export default orders;
